module.exports = __webpack_public_path__ + "static/media/fac15.1b646c23.jpg";